export class CompositeArticleModel {
    articleId: number = 0;
    companyId: number = 0;
    code: number = 0;
    alterCode: string | null = null;
    alterCode2: string | null = null;
    name: string = '';
    observation: string | null = null;
    active: boolean = true;
    familyId: number = 0;
    groupId: number = 0;
    subgroupId: number = 0;
    swComposite: boolean = false;
    createDate: string = '';
    userNameCreate: string = '';
    updateDate: string | null = null;
    userNameUpdate: string | null = null;
}